import { render } from "./ScheduleAnnotations.vue?vue&type=template&id=079337fd"
import script from "./ScheduleAnnotations.vue?vue&type=script&lang=js"
export * from "./ScheduleAnnotations.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__